import { EmailForm } from "@/components/common/EmailForm";
import FadeUpText from "@/components/ui/FadeUp";

export function HeroSection() {
  return (
    <section
      className="relative mx-auto my-0 flex min-h-screen w-full max-w-full flex-col items-center justify-center overflow-x-hidden rounded-2xl px-6 text-center max-sm:px-4
      bg-vw-bg-light dark:bg-vw-bg dark:bg-[url('/assets/images/common/HerobgImage.png')] dark:bg-cover dark:bg-center dark:bg-no-repeat"
    >
      <div className="mx-auto my-0 max-w-[800px]">
        <div className="inline-flex px-4 py-1.5">
          <FadeUpText>
            <div className="mb-3 w-fit rounded-3xl border border-blue-200 bg-blue-100 px-3 py-1.5 text-sm font-semibold tracking-widest text-blue-700 md:tracking-[0.2em] dark:border-transparent dark:bg-blue-500/30 dark:text-blue-400">
              ABOUT VAWENA
            </div>
          </FadeUpText>
        </div>
        <FadeUpText>
          <h1 className="mb-6 text-5xl font-bold leading-none text-gray-900 max-md:text-4xl max-sm:text-3xl dark:bg-clip-text dark:text-white">
            Built by Frustrated Investors Who Believe In Investment Through
            Intelligence
          </h1>

          <p className="mb-10 text-xl leading-relaxed text-gray-600 max-md:text-lg max-sm:text-base dark:text-slate-400">
            We experienced every problem you&apos;re facing — so we built the intelligent solution that puts investment success through AI-powered
            intelligence
          </p>
        </FadeUpText>
        <div className="flex flex-wrap items-center justify-center gap-4 max-md:flex-col">
          <EmailForm />
        </div>
      </div>
    </section>
  );
}
